import * as actionTypes from './actionTypes';

export const setIdToUpdate=(id)=>({
    type:actionTypes.SET_ID_TO_UPDATE,
    payload:id
})